import React from "react";
import { Text, View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";
import { setPlaceColours } from "../picks/HorseLine";
import { getOrdinalString } from "./PickEmOutcomeDisplay";

export interface PickEmPropProps {
    index: number;
    horseInfo: { horseName: string; odds: string; saddleNumber: number };
    realPlacement?: number;
}

export const HorseLineOutcomeDisplay = ({ index, horseInfo, realPlacement }: PickEmPropProps): JSX.Element => {
    const styles = useDynamicStyles(generateStyles);

    const [backgroundColour, textColour] = setPlaceColours(horseInfo.saddleNumber);

    const horseNumberColourStyle = [{ color: textColour }];
    const backgroundColourStyle = [{ backgroundColor: backgroundColour }];

    let secondBorder;
    if (horseInfo.saddleNumber === 2) {
        secondBorder = [
            {
                borderColor: textColour,
                borderWidth: EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            },
        ];
    }

    return (
        <View style={[styles.prop]}>
            {realPlacement !== undefined && isFinite(realPlacement) && (
                <View style={styles.placementContainer}>
                    <Text style={styles.placementText}>
                        {realPlacement >= 0 ? `${realPlacement + 1}${getOrdinalString(realPlacement + 1)}` : "SCR"}
                    </Text>
                </View>
            )}
            <View style={[styles.horseNumberContainer, backgroundColourStyle, secondBorder]}>
                <Text style={[styles.horseNumber, horseNumberColourStyle]}>{horseInfo.saddleNumber}</Text>
            </View>
            <Text style={styles.horseName}>{horseInfo.horseName}</Text>
            <Text style={styles.odds}>{horseInfo.odds}</Text>
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        prop: {
            height: 24,
            width: "100%",
            alignItems: "center",
            flexDirection: "row",
            marginVertical: 2.5,
        },
        horseName: {
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontWeight: "700",
            fontSize: 12,
            marginRight: "auto",
        },
        odds: {
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontWeight: "700",
            textAlign: "right",
            fontSize: 12,
        },
        horseNumberContainer: {
            width: 24,
            height: 24,
            borderRadius: 8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            marginRight: 5,
        },
        horseNumber: {
            fontSize: 12,
            fontWeight: "700",
        },
        placementContainer: {
            width: 36,
            height: 22,
            borderColor: () => EStyleSheet.value(GlobalStyles.HR_PLACEMENT_BORDER),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.HR_PLACE_CARD_BORDER_RADIUS),
            justifyContent: "center",
            alignItems: "center",
            marginRight: 5,
        },
        placementText: {
            width: "100%",
            height: 18,
            textAlign: "center",
            lineHeight: 14,
            fontSize: 12,
            fontWeight: "700",
            color: () => EStyleSheet.value(GlobalStyles.HR_PLACEMENT_TEXT),
            borderColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.HR_PLACE_CARD_BORDER_RADIUS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.HR_PLACEMENT_BACKGROUND),
        },
    });
};
